import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardElementTextControl, {
  CARD_ELEMENT_TEXT_MAX_CHARS,
} from './CardElementTextControl/CardElementTextControl';
import { isCardElementEditable } from '../AccountCard/helpers';
import CardElementTextFormat from './CardElementTextFormat';
import {
  getCardElementTextFontFamily,
  googleFontInfo,
} from '../../../../components/global/CardDesigner/components/CardDesignerCardElements/CardDesignerCardElementText/helpers';
import GoogleFontLoader from './GoogleFontLoader';

const propTypes = {
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
    side: PropTypes.string.isRequired,
    loading: PropTypes.bool,
  }),
  onChange: PropTypes.func.isRequired,
  fitText: PropTypes.bool,
};

const CardElementText = ({ element, onChange, fitText }) => {
  const [editing, setEditing] = useState(false);
  const { defaultCardElementConfiguration, cardElementConfiguration } = element;
  const {
    text,
    help_placeholder: placeholderText,
    font_family: fontFamily,
    text_transform: textTransform,
  } = cardElementConfiguration;
  const {
    font_family: defaultFontFamily,
    text_transform: defaultTextTransform,
  } = defaultCardElementConfiguration ?? {};
  const isEditable = isCardElementEditable(element);
  const googleFontDetails = googleFontInfo.find(x => x.font === fontFamily);
  const defaultGoogleFontDetails = googleFontInfo.find(
    x => x.font === defaultFontFamily,
  );

  return (
    <Fragment>
      {googleFontDetails && <GoogleFontLoader fontFamily={fontFamily} />}
      {defaultGoogleFontDetails && (
        <GoogleFontLoader fontFamily={defaultFontFamily} />
      )}
      <a
        href="#"
        className={classNames({
          'card-element card-element-text': true,
          'card-element-loading': element.loading,
        })}
        onClick={event => {
          event.preventDefault();

          if (!isEditable) {
            return;
          }

          setEditing(true);
        }}
      >
        <div
          className={classNames({
            'card-element-text-value': true,
            'card-element-text-value-no-fit': !fitText,
            'card-element-text-no-value': !text,
          })}
          style={{
            color:
              cardElementConfiguration.font_color ??
              defaultCardElementConfiguration?.font_color ??
              undefined,
            fontFamily:
              getCardElementTextFontFamily(cardElementConfiguration) ??
              getCardElementTextFontFamily(defaultCardElementConfiguration),
            textTransform:
              textTransform?.toLowerCase?.() ??
              defaultTextTransform?.toLowerCase?.() ??
              undefined,
            textAlign:
              cardElementConfiguration.text_align?.toLowerCase?.() ??
              defaultCardElementConfiguration?.text_align?.toLowerCase?.() ??
              undefined,
            fontWeight:
              cardElementConfiguration.font_weight?.toLowerCase?.() ??
              defaultCardElementConfiguration?.font_weight?.toLowerCase?.() ??
              undefined,
            fontStyle:
              cardElementConfiguration.font_style?.toLowerCase?.() ??
              defaultCardElementConfiguration?.font_style?.toLowerCase?.() ??
              'normal',
          }}
        >
          <CardElementTextFormat
            fitText={fitText}
            text={text || placeholderText || 'Write your message here...'}
          />
        </div>

        {isEditable && (
          <span className="card-element-text-char-count text-xs text-muted">
            {(text ?? '').length}/{CARD_ELEMENT_TEXT_MAX_CHARS}
          </span>
        )}
      </a>

      <CardElementTextControl
        forceOpen={editing}
        onClose={() => setEditing(false)}
        onChange={value =>
          onChange(element, {
            text: value,
          })
        }
        defaultValue={text}
        cardElementConfiguration={cardElementConfiguration}
        defaultCardElementConfiguration={defaultCardElementConfiguration}
      />
    </Fragment>
  );
};

CardElementText.propTypes = propTypes;

export default CardElementText;
